import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Grid, Box, Select, MenuItem, FormControl, InputLabel, Typography } from "@mui/material";
import BackgroundBlogCard from "examples/Cards/BlogCards/BackgroundBlogCard";
import MKBox from "components/MKBox";
import DefaultFooter from "examples/Footers/DefaultFooter";
import footerRoutes from "footer.routes";

import { Helmet } from "react-helmet-async";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";

// Routes
import routes from "routes";
const actividades = [
  // --- DERECHO LABORAL Y ABUSOS (4) ---
  {
    image: "https://mediosdelaire.com.ar/resources/contenidos/230222114537_3Mg6XSsRAkmin.jpg",
    title: "Jornada de Derecho Laboral Panadero",
    description: "Actualización normativa, derechos del trabajador y obligaciones del empleador.",
    fecha: "2025-12-22",
    genero: "unisex",
  },
  {
    image: "https://i.ytimg.com/vi/Nn2YbgH4W0M/hq720.jpg",
    title: "Taller de Prevención del Abuso Laboral",
    description:
      "Herramientas para identificar y denunciar el hostigamiento, maltrato y discriminación.",
    fecha: "2025-11-10",
    genero: "femenino",
  },
  {
    image:
      "https://www.danielcolombo.com/wp-content/uploads/2022/02/mobbing-acoso-laboral-jefe-mano-hombro-mujer-escritorio.jpg",
    title: "Seminario sobre Violencia y Acoso en el Trabajo",
    description: "Basado en el Convenio 190 de la OIT. Derechos, protección y vías de acción.",
    fecha: "2025-10-05",
    genero: "unisex",
  },
  {
    image:
      "https://scontent-eze1-1.xx.fbcdn.net/v/t1.6435-9/87484919_10221726974311862_8232552540848259072_n.jpg",
    title: "Consultorio Jurídico Abierto",
    description:
      "Consultas mensuales sobre despidos, salarios, categorías y condiciones de trabajo.",
    fecha: "2025-09-18",
    genero: "masculino",
  },

  // --- OTRAS ACTIVIDADES (6) ---
  {
    image: "https://imgv2-2-f.scribdassets.com/img/document/610180808/original/adc77f071e/1?v=1",
    title: "Capacitación en Seguridad e Higiene",
    description: "Formación técnica sobre manipulación segura de alimentos en panaderías.",
    fecha: "2025-08-12",
    genero: "unisex",
  },
  {
    image:
      "https://www.espectalium.com/wp-content/uploads/2017/09/Por-que%CC%81-apostar-por-una-charla-motivacional-en-tu-evento-scaled.jpg",
    title: "Charla Motivacional para Trabajadores",
    description: "Estrategias para el bienestar emocional, motivación y trabajo en equipo.",
    fecha: "2025-07-20",
    genero: "femenino",
  },
  {
    image: "https://femcet.com/wp-content/uploads/2021/10/coaching-empresarial.webp",
    title: "Coaching Laboral y Desarrollo Profesional",
    description: "Herramientas para mejorar habilidades y crecimiento personal.",
    fecha: "2025-06-15",
    genero: "masculino",
  },
  {
    image:
      "https://sonidogremial.com.ar/wp-content/uploads/2023/11/PACHI_ENCUENTRO_MUJERES_SAN_JUAN_1.jpg",
    title: "Encuentro de Trabajadores Panaderos",
    description: "Espacio abierto de diálogo, colaboración y propuestas del sector.",
    fecha: "2025-05-10",
    genero: "unisex",
  },
  {
    image: "https://manospanaderas.com/wp-content/uploads/2024/06/Produccion-scaled.jpg",
    title: "Workshop de Producción Panadera",
    description: "Taller práctico sobre técnicas modernas y tradicionales de panificación.",
    fecha: "2025-04-04",
    genero: "masculino",
  },
  {
    image: "https://proingra.com/wp-content/uploads/2021/02/25-FEB-Imagen-Articulo-BRAHMAN.jpg",
    title: "Círculo de Bienestar Laboral",
    description: "Espacio mensual para hablar de estrés, convivencia y cuidado de la salud mental.",
    fecha: "2025-03-01",
    genero: "femenino",
  },
];

export default function ActividadesAfiliadosPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const generoURL = searchParams.get("genero") || "todas";

  const [filtro, setFiltro] = useState(generoURL);

  useEffect(() => {
    setFiltro(generoURL);
  }, [generoURL]);

  useEffect(() => {
    setSearchParams({ genero: filtro });
  }, [filtro, setSearchParams]);

  const actividadesFiltradas = actividades.filter((act) => {
    if (filtro === "todas") return true;
    if (filtro === "femenino") return act.genero === "femenino" || act.genero === "unisex";
    if (filtro === "masculino") return act.genero === "masculino" || act.genero === "unisex";
    return true;
  });

  return (
    <>
      <Helmet>
        <title>Actividades para Afiliados | Sindicato Panaderos San Juan</title>

        <meta
          name="description"
          content="Conocé las actividades, capacitaciones y eventos organizados por el Sindicato de Panaderos de San Juan para sus afiliados."
        />

        <meta
          name="keywords"
          content="panaderos san juan, sindicato panaderos, actividades afiliados, capacitaciones panadería, eventos sindicato"
        />

        {/* Open Graph (para compartir en redes) */}
        <meta property="og:title" content="Actividades para Afiliados" />
        <meta
          property="og:description"
          content="Capacitaciones, talleres y eventos del sindicato."
        />
      </Helmet>
      <DefaultNavbar
        routes={routes}
        action={{
          type: "external",
          route: "/afiliate",
          label: "Afiliate",
          color: "info",
        }}
        transparent
        light
      />

      <MKBox bgColor="white">
        <MKBox
          minHeight="25rem"
          width="100%"
          sx={{
            backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
              `${linearGradient(
                rgba(gradients.dark.main, 0.8),
                rgba(gradients.dark.state, 0.8)
              )}, url("https://www.lesaffreargentina.com.ar/wp-content/uploads/2018/09/Noticia3-1024x577.jpg")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "grid",
            placeItems: "center",
          }}
        />

        <Box sx={{ p: 20 }}>
          <Typography
            variant="h4"
            fontWeight="bold"
            mb={1}
            sx={{
              marginTop: "-5rem",
            }}
          >
            Actividades de nuestro Sindicato
          </Typography>
          <Box sx={{ width: "100%", height: "3px", backgroundColor: "#2196f3", mb: 4 }} />
          {/* SELECT */}
          <Box
            sx={{
              mb: 4,
              maxWidth: 300,
              mx: "auto", // ✅ centra horizontalmente
            }}
          >
            <FormControl fullWidth>
              <InputLabel id="select-genero-label">Seleccioná el género de la actividad</InputLabel>

              <Select
                labelId="select-genero-label"
                value={filtro}
                label="Seleccioná el género de la actividad"
                onChange={(e) => setFiltro(e.target.value)}
                sx={{ color: "#000000", height: "3rem" }}
              >
                <MenuItem value="todas">Todas</MenuItem>
                <MenuItem value="femenino">Femeninas</MenuItem>
                <MenuItem value="masculino">Masculinas</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* GRID */}
          <Grid container spacing={3}>
            {actividadesFiltradas.map((item) => (
              <Grid item xs={12} sm={6} lg={3} key={item.id}>
                <Box sx={{ height: 380 }}>
                  <BackgroundBlogCard
                    image={item.image}
                    title={item.title}
                    description={item.description}
                    action={{
                      type: "internal",
                      route: `/formularioinscripcionactividades`,
                      label: "Inscríbite",
                    }}
                    sx={{ height: "100%", backgroundSize: "cover" }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Box>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}
